import React, { FunctionComponent, RefObject } from 'react';

type Props = {
  id?: string;
  type?: string;
  value?: string | number;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  className?: string;
  placeholder?: string;
  name?: string;
  disabled?: boolean;
  required?: boolean;
  accept?: string;
  multiple?: boolean;
  maxLength?: number;
  checked?: boolean;
  hidden?: boolean;
  inputRef?: RefObject<HTMLInputElement>;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
};

export const Presentation: FunctionComponent<Props> = ({
  id,
  type = 'text',
  value,
  onChange,
  onBlur,
  className = '',
  placeholder = '',
  name,
  disabled = false,
  required = false,
  accept,
  multiple = false,
  maxLength,
  checked,
  hidden,
  inputRef,
  inputMode
}) => {
  const handleWheel =
    type === 'number'
      ? (e: React.WheelEvent<HTMLInputElement>) => {
          e.currentTarget.blur();
        }
      : undefined;

  return (
    <input
      id={id}
      type={type}
      name={name}
      value={type === 'file' ? undefined : value}
      onChange={onChange}
      onBlur={onBlur}
      onWheel={handleWheel}
      className={className}
      placeholder={placeholder}
      disabled={disabled}
      required={required}
      accept={accept}
      multiple={multiple}
      maxLength={maxLength}
      checked={checked}
      hidden={hidden}
      ref={inputRef}
      inputMode={inputMode}
    />
  );
};
